export * from './recommendation-card.component';
export * from './recommendation-card.module';
export * from './recommendation-card-actions/recommendation-card-actions.component';
export * from './recommendation-card-cover/recommendation-card-cover.component';
export * from './recommendation-card-feature/recommendation-card-feature.component';
export * from './recommendation-card-icon/recommendation-card-icon.component';
export * from './recommendation-card-media/recommendation-card-media.component';
export * from './recommendation-card-static/recommendation-card-static.component';
export * from './recommendation-card-tag/recommendation-card-tag.component';
export * from './recommendation-card-text/recommendation-card-text.component';
export * from './recommendation-card-title/recommendation-card-title.component';

export { RecommendationCardTitleComponent } from './recommendation-card-title/recommendation-card-title.component';
